import classnames from 'classnames';
import { LocationDescriptorObject } from 'history';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { Highlight } from 'src/app/graph/insights/fieldPage/type/highlight/Highlight';

interface BaseProps {
  printedType: string | null;
  highlightText?: string | null;
  color?: string | null;
}

interface HrefProps extends BaseProps {
  hrefPrefix?: string;
}

interface ToProps extends BaseProps {
  to?: LocationDescriptorObject;
}

export const TypeString = (props: HrefProps | ToProps) => {
  const { printedType, color, highlightText } = props;
  // Split printed type into type name and modifier prefix/suffix
  const match =
    printedType && /([\[]*)([_A-Za-z][_0-9A-Za-z]*)([\]!]*)/g.exec(printedType);
  if (!match) {
    return null;
  }
  const [, prefix, typeName, suffix] = match;

  const childText = highlightText ? (
    <Highlight text={typeName} query={highlightText} />
  ) : (
    typeName
  );

  return (
    <>
      {prefix}
      <span className="font-mono text-link">
        {'to' in props && props.to !== undefined ? (
          <Link to={props.to}>{childText}</Link>
        ) : 'hrefPrefix' in props ? (
          <a
            className={classnames(
              'font-semibold hover:underline',
              color || 'text-link',
            )}
            onClick={(e) => e.stopPropagation()}
            href={`${props.hrefPrefix}${typeName}`}
          >
            {childText}
          </a>
        ) : (
          <b>{childText}</b>
        )}
      </span>
      {suffix}
    </>
  );
};
